import clsx from 'clsx'
import DOMPurify from 'isomorphic-dompurify'
import { FC } from 'react'

import styles from './extra-field.module.scss'

interface IExtraField {
  fieldName: string
  fieldValue: string | number
  modificator?: string
}

const ExtraField: FC<IExtraField> = ({ fieldName, fieldValue, modificator }) => {
  return (
    <div
      className={clsx(styles.fieldWrapper, {
        [modificator as string]: modificator,
      })}
    >
      <p className={styles.name}>{fieldName}:</p>
      {typeof fieldValue === 'string' ? (
        <p
          className={styles.value}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(fieldValue),
          }}
        />
      ) : (
        <p className={styles.value}>{fieldValue}</p>
      )}
    </div>
  )
}

export default ExtraField
